  //Package Protection Fee Add To Cart
  if (typeof Shopify === 'undefined') var Shopify = {};
    Shopify.cart = null;

    const variants = {1:"41998625112292", 51:"41998625145060", 101:"41998628192484", 201:"41998628618468", 301:"41998630617316", 401:"41998631469284", 501:"41998631993572", 601:"41998634090724", 701:"41998634680548", 801:"41998636646628", 901:"41998636810468", 1001:"41998638711012", 1101:"41998643855588", 1201:"41998646182116", 1301:"41998646640868", 1401:"41998647394532", 1501:"41998648934628", 1601:"41998650474724", 1701:"41998652047588", 1801:"41998653718756", 1901:"41998653980900", 2001:"41998658535652", 2101:"41998659027172", 2201:"41998659125476", 2301:"41998660403428", 2401:"41998660534500", 2501:"41998661189860", 2601:"41998663188708", 2701:"41998663450852", 2801:"41998665089252", 2901:"41998665318628", 3001:"41998665416932"};
  	var variants_Keys = Object.keys(variants);

    var surchargeInCart = false;
  	var total = 200; // total in cents.
  	var sub_total = Shopify.cart.total_price; 


    var sub_total = parseInt(sub_total),
    	sub_total = (sub_total / 100).toFixed(2);

    if(sub_total >= 1 && sub_total<=50.99) {
   		Shopify.toAdd = variants[1];
    }
    if(sub_total >= 51 && sub_total<=100.99) {
   		Shopify.toAdd = variants[51];
    }
    if(sub_total >= 101 && sub_total<=200.99) {
   		Shopify.toAdd = variants[101];
    }
    if(sub_total >= 201 && sub_total<=300.99) {
   		Shopify.toAdd = variants[201];
    }
    if(sub_total >= 301 && sub_total<=400.99) {
   		Shopify.toAdd = variants[301];
    }
    if(sub_total >= 401 && sub_total<=500.99) {
   		Shopify.toAdd = variants[401];
    }
    if(sub_total >= 501 && sub_total<=600.99) {
   		Shopify.toAdd = variants[501];
    }
    if(sub_total >= 601 && sub_total<=700.99) {
   		Shopify.toAdd = variants[601];
    }
    if(sub_total >= 701 && sub_total<=800.99) {
   		Shopify.toAdd = variants[701];
    }
    if(sub_total >= 801 && sub_total<=900.99) {
   		Shopify.toAdd = variants[801];
    }
    if(sub_total >= 901 && sub_total<=1000.99) {
   		Shopify.toAdd = variants[901];
    }
    if(sub_total >= 1001 && sub_total<=1100.99) {
   		Shopify.toAdd = variants[1001];
    }
    if(sub_total >= 1101 && sub_total<=1200.99) {
   		Shopify.toAdd = variants[1101];
    }
    if(sub_total >= 1201 && sub_total<=1300.99) {
   		Shopify.toAdd = variants[1201];
    }
    if(sub_total >= 1301 && sub_total<=1400.99) {
   		Shopify.toAdd = variants[1301];
    }
    if(sub_total >= 1401 && sub_total<=1500.99) {
   		Shopify.toAdd = variants[1401];
    }
    if(sub_total >= 1501 && sub_total<=1600.99) {
   		Shopify.toAdd = variants[1501];
    }
    if(sub_total >= 1601 && sub_total<=1700.99) {
   		Shopify.toAdd = variants[1601];
    }
    if(sub_total >= 1701 && sub_total<=1800.99) {
   		Shopify.toAdd = variants[1701];
    }
    if(sub_total >= 1801 && sub_total<=1900.99) {
   		Shopify.toAdd = variants[1801];
    }
    if(sub_total >= 1901 && sub_total<=2000.99) {
   		Shopify.toAdd = variants[1901];
    }
    if(sub_total >= 2001 && sub_total<=2100.99) {
   		Shopify.toAdd = variants[2001];
    }
    if(sub_total >= 2101 && sub_total<=2200.99) {
   		Shopify.toAdd = variants[2101];
    }
    if(sub_total >= 2201 && sub_total<=2300.99) {
   		Shopify.toAdd = variants[2201];
    }
    if(sub_total >= 2301 && sub_total<=2400.99) {
   		Shopify.toAdd = variants[2301];
    }
    if(sub_total >= 2401 && sub_total<=2500.99) {
   		Shopify.toAdd = variants[2401];
    }
    if(sub_total >= 2501 && sub_total<=2600.99) {
   		Shopify.toAdd = variants[2501];
    }
    if(sub_total >= 2601 && sub_total<=2700.99) {
   		Shopify.toAdd = variants[2601];
    }
    if(sub_total >= 2701 && sub_total<=2800.99) {
   		Shopify.toAdd = variants[2701];
    }
    if(sub_total >= 2801 && sub_total<=2900.99) {
   		Shopify.toAdd = variants[2801];
    }
    if(sub_total >= 2901 && sub_total<=3000.99) {
   		Shopify.toAdd = variants[2901];
    }
    if(sub_total >= 3001) {
   		Shopify.toAdd = variants[3001];
    }

    for (var i=0; i<Shopify.cart.items.length; i++) {
      if (Shopify.cart.items[i].id == Shopify.toAdd) {
          surchargeInCart = true;
          total -= Shopify.cart.items[i].line_price;
          sub_total = Shopify.cart.total_price - Shopify.cart.items[i].line_price;
      }
    }

  jQuery(".cart-remove-btns .btn--small.small--hide, .cart-remove-btns .mobile-cart-remove-btn").click(function(e){
    var protection_prd_id = jQuery(this).data("prd-id");
    if(protection_prd_id == Shopify.toAdd) {
      	document.cookie = "protection_prd_id=remove";
    }
  });

  if (!surchargeInCart && total < 5000 && total >= 0 && Shopify.cart.items.length != 0 && getCookie("protection_prd_id") != "remove") {

    for (var i=0; i<Shopify.cart.items.length; i++) {
      if (Shopify.cart.items[i].product_id == 7193830228117) {
      	$.ajax({
            url: '/cart/change.js',
            data: 'quantity=0&id=' + Shopify.cart.items[i].id,
            dataType: 'json',
            async:false,
            success: function(data)
            {
                console.log("Product Removed Success");
            },
            complete: function (data) {
                console.log("Remove AJAX Complete");
            }
        });
      }
    }

    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=1&id=' + Shopify.toAdd,
      dataType: 'json',
      success: function(line_item) { 
        window.location.href = '/cart';
      }
    };
    jQuery.ajax(params);
  }

  jQuery(".product-single__form button.add-to-cart").click(function(eve){
  	eve.preventDefault();
    document.cookie = "protection_prd_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "protection_prd_id=add";
    jQuery("form.product-single__form").submit();
  });

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
